.button {
  height: var(--control-h);
  padding: 0 14px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
  background: var(--surface);
  color: var(--text);
  white-space: nowrap;
}

.button:hover:not(:disabled) {
  background: var(--surface-muted);
}

.button:disabled {
  opacity: 0.5;
}

.primary {
  background: var(--accent);
  border-color: var(--accent);
  color: var(--white);
  font-weight: 600;
}

.primary:hover:not(:disabled) {
  background: var(--accent-700);
}

.danger {
  color: var(--danger);
  border-color: color-mix(in srgb, var(--danger) 40%, var(--border));
}

.ghost {
  border-color: transparent;
  background: transparent;
  color: var(--text-muted);
}
